const mediaItems = [
  {
    title: '明星红毯造型大盘点',
    desc: '回顾近期各大颁奖礼与时尚活动红毯，解析明星穿搭亮点与槽点',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20fashion%20runway%20and%20red%20carpet%20illustration%20with%20elegant%20silhouettes%2C%20warm%20coral%20and%20amber%20tones%2C%20modern%20minimal%20editorial%20style%2C%20soft%20gradient%20background&width=800&height=500&seq=media-01&orientation=landscape',
    duration: '15:32',
    views: '128万',
  },
  {
    title: '综艺名场面合集',
    desc: '那些年综艺节目中的经典片段与高能时刻，一次看过瘾',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20TV%20show%20studio%20set%20illustration%20with%20colorful%20lights%20and%20dynamic%20composition%2C%20warm%20coral%20amber%20palette%2C%20modern%20flat%20design%2C%20entertainment%20theme&width=800&height=500&seq=media-02&orientation=landscape',
    duration: '08:45',
    views: '96万',
  },
  {
    title: '娱乐圈十年变迁回顾',
    desc: '从2015到2025，娱乐圈经历了怎样的巨变，一篇文章带你重温',
    img: 'https://readdy.ai/api/search-image?query=Timeline%20illustration%20with%20floating%20year%20markers%20and%20pop%20culture%20icons%20in%20warm%20coral%20amber%20gradient%2C%20modern%20minimal%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=media-03&orientation=landscape',
    duration: '22:10',
    views: '85万',
  },
  {
    title: '明星私服穿搭教学',
    desc: '跟明星学穿搭，日常出街也能穿出时尚感，实用搭配指南',
    img: 'https://readdy.ai/api/search-image?query=Fashion%20wardrobe%20and%20clothing%20rack%20illustration%20in%20warm%20coral%20amber%20tones%2C%20modern%20minimal%20style%2C%20clean%20editorial%20look%2C%20soft%20gradient%20background&width=800&height=500&seq=media-04&orientation=landscape',
    duration: '12:18',
    views: '73万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">精彩视频</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">精选热门视频专题，视觉吃瓜更过瘾</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div key={item.title} className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer">
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs px-1.5 py-0.5 rounded bg-black/60 text-background-50 whitespace-nowrap">{item.duration}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.views} 次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}